module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-24.88e0d738.png";